import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from 'app/src/queries/withCount';

export const ACH_BATCH_FIELDS = gql`
  fragment AchBatchFields on AchBatch {
    id
    bankDate
    sentAt
    groupedEntries {
      entityType
      entityId
      entityName
      entries {
        id
        entityType
        entityId
        entityName
        txn {
          id
          bankDate
          amount: amount(increasedBy: "credit")
        }
        saleAsset {
          id
          lotNumber
          sellerAchInstRec
          sellerAchOn
          invoiceNumber
          asset {
            year
            make
            model
            vin
            stockNumber
          }
        }
      }
    }
  }
`;

export const ACH_BATCHES_WITH_COUNT = gql`
  ${ACH_BATCH_FIELDS}
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    achBatchesWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ...AchBatchFields
      }
      count
    }
  }
`;
